<template>
  <div id="author-co-author-manuscripts">
    <div class="ipub-h1 mar-b-20 line-h-40 relative">
      Co-author’s Submitted Manuscripts
    </div>
    <ipub-row :gutter="[12, 16]">
      <ipub-col :span="12">
        <site-search-group v-model.trim="params.keyword"
                           placeholder="Search by manuscript no., title"
                           @search="getList()"
                           @clear="handleClear" />
      </ipub-col>
    </ipub-row>
    <div class="page-content">
      <ipub-table :columns="columns"
                  :empty="{icon:'iconSI_article'}"
                  :pagination="pagination"
                  @order="onOrderChanage"
                  :dataSource="dataSource">
        <template v-slot:submitter="{record}">
          <div v-if="record.submitter">
            <div>{{record.submitter.firstName}} {{record.submitter.lastName}}</div>
            <div>{{record.submitter.email}}</div>
          </div>
          <div v-else>- -</div>
        </template>

        <template v-slot:firstSubmitTime="{record}">
          <span>{{ (record.firstSubmitTime)?$moment(record.firstSubmitTime).format('DD / MM / YYYY'): '- -' }}</span>
        </template>
        <template v-slot:date="{record}">
          <div v-if="status1[record.status]!='Timeout'">
            <p class="ipub-p2 fw-bd">{{status1[record.status]}}</p>
            <span>{{ (record.statusTime)?$moment(record.statusTime).format('DD / MM / YYYY'): '- -' }}</span>
          </div>
          <span v-else>Timeout</span>
        </template>
        <template v-slot:actions="{ record }">

          <div v-show="['PENDING_MINOR_REVISIONS','PENDING_MAJOR_REVISIONS','SUBMITTED','PENDING_REVIEW','PENDING_APC_CONFIRM','PENDING_PRE_CHECK','PRE_CHECK_DONE','PENDING_FIRST_DECISION','FIRST_DECISION_DONE','PENDING_FINAL_DECISION','FINAL_DECISION_DONE','PENDING_DECISION','REVISED_VERSION_REVIEW','UNDER_REVIEW','RESUBMISSION','REVISED_REVIEW'].includes(record.status)">
            <ipub-tooltip class="border-right">
              <div slot="title">Details</div>
              <ipub-icon type="iconViewDetails"
                         @click="detail(record)" />
            </ipub-tooltip>
          </div>
          <div v-show="['PAPER_ACCEPTED','REJECTED','WITHDRAWN','ONLINE'].includes(record.status)">
            <ipub-tooltip>
              <div slot="title">View the decision</div>
              <ipub-icon type="iconManuscript"
                         @click="decision(record)" />
            </ipub-tooltip>
          </div>
          <div v-show="record.coAuthor && record.coAuthor.status==='NO_RESPONSE'">
            <ipub-tooltip class="border-right">
              <div slot="title">Verify Co-Authorship</div>
              <ipub-icon type="iconverification-code"
                         @click="verify(record)" />
            </ipub-tooltip>
          </div>

        </template>
      </ipub-table>
      <Detail :isVisable="isVisableDetail"
              :inputData="inputData"
              @cancel="cancel" />
      <VerifyCoAuthorship :isVisable="showVerify"
                          @confirm="confirm"
                          @decline="decline"
                          :inputData="inputData"
                          @cancel="cancel" />
      <CoAuthorshipConfirm :isVisable="showConfirm"
                           :inputData="inputData"
                           @confirmSubmit="confirmSubmit"
                           @cancel="cancel" />
      <CoAuthorshipDecline :isVisable="showDecline"
                           :inputData="inputData"
                           @declineSubmit="declineSubmit"
                           @cancel="cancel" />

    </div>
  </div>

</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>